export const removeEmpty = (obj: Record<string, any>) => {
  const newObj: Record<string, any> = {};
  Object.keys(obj).forEach((key) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    if (obj[key] === Object(obj[key])) newObj[key] = removeEmpty(obj[key]);
    else if (obj[key] !== undefined) newObj[key] = obj[key];
  });
  return newObj;
};

export const isValidId = (id: string) => {
  if (!id) return false;
  // Example validation for a 24-character hexadecimal string
  const hexRegex = /^[0-9a-fA-F]{24}$/;
  return hexRegex.test(id);
};

export default {};
